import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {ItemDetailDatalist_Create,ItemDetailDatalist_Update,ItemDetailDatalist_Delete,ItemDetailDatalist_ReadById,ItemDetailDatalist_ReadByItemId,ItemDetailDatalist_ReadAll,ItemDetailDatalist_CreateBulk} from 'src/app/GlobalVariables';
import {ItemDetailDatalistCreateRequestDTO,ItemDetailDatalistUpdateRequestDTO,ItemDetailDatalistDeleteRequestDTO,ItemDetailDatalistReadByIdRequestDTO,ItemDetailDatalistReadByItemIdRequestDTO,ItemDetailDatalistDTO, ItemDetailDatalistList, ItemDetailDatalistCreateBulkRequestDTO, ItemDetailDatalistCreateBulkList } from './Item-detail-datalist.interface';

@Injectable({
    providedIn: 'root'
})
export class ItemDetailDatalistService {

    constructor(private http: HttpClient) { }

    ItemDetail_create(data: ItemDetailDatalistCreateRequestDTO): Observable<ItemDetailDatalistDTO> {
        return this.http.post<ItemDetailDatalistDTO>(ItemDetailDatalist_Create, data);
    }

    ItemDetail_update(data: ItemDetailDatalistUpdateRequestDTO): Observable<ItemDetailDatalistDTO> {
        return this.http.post<ItemDetailDatalistDTO>(ItemDetailDatalist_Update, data);
    }

    ItemDetail_delete(data: ItemDetailDatalistDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(ItemDetailDatalist_Delete, data);
    }

    ItemDetail_readById(data: ItemDetailDatalistReadByIdRequestDTO): Observable<ItemDetailDatalistDTO> {
        return this.http.post<ItemDetailDatalistDTO>(ItemDetailDatalist_ReadById, data);
    }

    ItemDetail_readByItemId(data: ItemDetailDatalistReadByItemIdRequestDTO): Observable<ItemDetailDatalistList> {
        return this.http.post<ItemDetailDatalistList>(ItemDetailDatalist_ReadByItemId, data);
    }

    ItemDetail_readAll(): Observable<ItemDetailDatalistList> {
        return this.http.get<ItemDetailDatalistList>(ItemDetailDatalist_ReadAll);
    }

    ItemDetail_createBulk(data: ItemDetailDatalistCreateBulkRequestDTO): Observable<ItemDetailDatalistCreateBulkList> {
        return this.http.post<ItemDetailDatalistCreateBulkList>(ItemDetailDatalist_CreateBulk, data);
    }
}
